/* BarkWise landing page behaviors:
   - region <select> keeps every buy form's hidden [name=id] in sync
   - sticky buy bar shows after the hero, hides while the buy box is on screen
   - click-to-load YouTube facade */
(function () {
  function syncVariantId(variantId) {
    document.querySelectorAll("[data-bwlp-variant-id]").forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll("[data-bwlp-region]").forEach(function (select) {
      if (select.value !== variantId) select.value = variantId;
    });
  }

  function initRegionSelects() {
    document.querySelectorAll("[data-bwlp-region]").forEach(function (select) {
      select.addEventListener("change", function () {
        syncVariantId(select.value);
      });
    });
    var first = document.querySelector("[data-bwlp-region]");
    if (first) syncVariantId(first.value);
  }

  function initStickyBar() {
    var bar = document.querySelector("[data-bwlp-sticky]");
    if (!bar) return;

    var hero = document.querySelector(".bwlp-hero");
    var buyBox = document.getElementById("barkwise-buy");
    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var pastHero = true;
      if (hero) pastHero = hero.getBoundingClientRect().bottom < 0;
      var buyOnScreen = false;
      if (buyBox) {
        var r = buyBox.getBoundingClientRect();
        buyOnScreen = r.top < vh - 60 && r.bottom > 0;
      }
      var show = pastHero && !buyOnScreen;
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate, { passive: true });
    update();
  }

  function initVideoFacades() {
    document.querySelectorAll("[data-bwlp-video]").forEach(function (frame) {
      var button = frame.querySelector(".bwlp-video__play");
      if (!button) return;
      button.addEventListener("click", function () {
        var videoId = frame.dataset.videoId;
        if (!videoId) return;
        var iframe = document.createElement("iframe");
        iframe.src =
          "https://www.youtube.com/embed/" +
          encodeURIComponent(videoId) +
          "?autoplay=1&modestbranding=1&rel=0";
        iframe.title = "BarkWise Complete in action";
        iframe.allow =
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        frame.innerHTML = "";
        frame.appendChild(iframe);
      });
    });
  }

  function initReveals() {
    var els = document.querySelectorAll("[data-bwlp-reveal]");
    if (!els.length) return;
    var reduce =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) return;

    els.forEach(function (el) {
      el.classList.add("bwlp-reveal");
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("bwlp-reveal--in");
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -7% 0px", threshold: 0.05 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });

    // Failsafe: never leave content hidden (in-app browsers, odd webviews).
    setTimeout(function () {
      els.forEach(function (el) {
        el.classList.add("bwlp-reveal--in");
      });
    }, 2500);
  }

  function init() {
    initRegionSelects();
    initStickyBar();
    initVideoFacades();
    initReveals();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
